import { render } from "./BaseFooter.vue?vue&type=template&id=5709c692&scoped=true"
import script from "./BaseFooter.vue?vue&type=script&lang=js"
export * from "./BaseFooter.vue?vue&type=script&lang=js"

import "./BaseFooter.vue?vue&type=style&index=0&id=5709c692&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5709c692"

export default script